import { forwardRef } from "react";
import { Icon, type Props } from "./SwitchIcon.Parts";

export const SwitchIcon = forwardRef<SVGSVGElement, Props>(
  ({ small, ...props }, ref) => (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $small={small}
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75605 5.94071H0.2C0.0895431 5.94071 0 5.85117 0 5.74071V4.11007C0 3.99962 0.0895431 3.91007 0.2 3.91007H2.75605C3.69853 3.91007 4.6024 4.28447 5.26884 4.9509L13.9351 13.6172C14.2207 13.9028 14.6081 14.0633 15.012 14.0633H17.7681V16.0939H15.012C14.0696 16.0939 13.1657 15.7195 12.4993 15.0531L3.83296 6.38678C3.54734 6.10117 3.15997 5.94071 2.75605 5.94071Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4992 4.9509C13.1657 4.28447 14.0696 3.91007 15.012 3.91007H17.7681V5.94071H15.012C14.6081 5.94071 14.2207 6.10117 13.9351 6.38678L11.6471 8.67478C11.569 8.75289 11.4424 8.75289 11.3643 8.67478L10.2112 7.52175C10.1331 7.44364 10.1331 7.31701 10.2112 7.23891L12.4992 4.9509Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83296 13.6172L6.12096 11.3292C6.19906 11.2511 6.3257 11.2511 6.4038 11.3292L7.55684 12.4822C7.63494 12.5603 7.63494 12.687 7.55684 12.7651L5.26884 15.0531C4.6024 15.7195 3.69853 16.0939 2.75605 16.0939H0.2C0.0895431 16.0939 0 16.0044 0 15.8939V14.2633C0 14.1528 0.0895431 14.0633 0.2 14.0633H2.75605C3.15997 14.0633 3.54734 13.9028 3.83296 13.6172Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6012 15.0786L14.6531 12.1305C14.575 12.0524 14.575 11.9258 14.6531 11.8477L15.8062 10.6946C15.8843 10.6165 16.0109 10.6165 16.089 10.6946L19.6653 14.2709C20.1114 14.717 20.1114 15.4402 19.6653 15.8863L16.089 19.4625C16.0109 19.5407 15.8843 19.5407 15.8062 19.4625L14.6531 18.3095C14.575 18.2314 14.575 18.1048 14.6531 18.0267L17.6012 15.0786Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6012 4.92539L14.6531 1.9773C14.575 1.89919 14.575 1.77256 14.6531 1.69446L15.8062 0.541421C15.8843 0.463316 16.0109 0.463316 16.089 0.541421L19.6653 4.1177C20.1114 4.56378 20.1114 5.287 19.6653 5.73307L16.089 9.30935C16.0109 9.38745 15.8843 9.38745 15.8062 9.30935L14.6531 8.15631C14.575 8.07821 14.575 7.95158 14.6531 7.87347L17.6012 4.92539Z"
        fill="currentColor"
      />
    </Icon>
  ),
);
